export default {
  baseURL: process.env.REACT_APP_IKT_WEBSHOP_API_BASE_URL,
  authDomain: process.env.REACT_APP_IKT_WEBSHOP_AUTH_DOMAIN,
  authClientId: process.env.REACT_APP_IKT_WEBSHOP_AUTH_CLIENT_ID,
};
